module.exports = __webpack_public_path__ + "img/money-wallet-open.689d8cc6.svg";